import TemplateView from "../../TemplateView"
import {bindActionCreators} from 'redux'
import {connect} from '../../redux/utils'

import {getExportState} from './selectors'
import {exportTaskListCsv} from './actions'
import messageResource from "../../messageResource"
import LoadingSpinner from '../../components/LoadingSpinner'
import {thereAreTableTasks} from '../tasksTable/selectors'

class CsvExportButton extends TemplateView {
    constructor({
        exportAction = () => {},
    }) {
        super()
        this.state = {
            disabled: false,
            inProgress: false,
        }
        this.callbacks = {
            exportAction,
        }
        this.onStatePropertyChanged('disabled', (disabled) => {
            this.getEl().toggleClass('disabled', disabled)
            this.getEl().prop('title', disabled ? messageResource.getMessage('task.list.export.no_data') : '')
        })
        this.onStatePropertyChanged('inProgress', (inProgress) => {
            this.getEl().toggleClass('inProgress', inProgress)
            this.spinner.setState({show: inProgress})
        })
    }

    templateHtml() {
        return " <div class='button'>" +
               "    <div class='icon'/>" +
               "    <div class='exportSpinner'/>" +
               "    <div class='label'><%=label%></div>" +
               " </div>"
    }

    messageKeys() {
        return {
            label: "task.list.export.csv",
        }
    }

    afterRender() {
        this.spinner = new LoadingSpinner().init(this.find(".exportSpinner"))
        this.bindClick(() => {
            if (this.state.disabled || this.state.inProgress) return
            this.callbacks.exportAction()
        })
    }
}

export default connect(
    (state) => ({
        disabled: getExportState(state).inProgress ? false : !thereAreTableTasks(state),
        inProgress: getExportState(state).inProgress,
    }),
    (dispatch) => ({
        exportAction: bindActionCreators(exportTaskListCsv, dispatch),
    })
)(CsvExportButton)



// WEBPACK FOOTER //
// ./web/js/taskManagement/exportCsv/CsvExportButton.js